import React, { useState, useEffect } from 'react';
import { Modal, DatePicker, Button, Typography } from 'antd';
import { Calendar, X } from 'lucide-react';
import dayjs from 'dayjs';

const { Text } = Typography;

const RescheduleModalV2 = ({ isOpen, onClose, onSave, initialTime, recordName }) => {
  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    if (isOpen) {
      if (initialTime && !initialTime.includes('1900')) {
        setSelectedDate(dayjs(initialTime, 'DD-MMM-YYYY HH:mm'));
      } else {
        setSelectedDate(dayjs().add(1, 'hour'));
      }
    }
  }, [isOpen, initialTime]);

  const handleSave = () => {
    if (!selectedDate || selectedDate.isBefore(dayjs())) {
      return;
    }
    onSave(selectedDate.format('DD-MMM-YYYY HH:mm'));
  };

  const disabledDate = (current) => {
    // Can not select days before today
    return current && current < dayjs().startOf('day');
  };

  return (
    <Modal
      title={
        <div className="flex items-center gap-2">
          <Calendar size={20} className="text-blue-600" />
          <span className="text-lg font-bold text-slate-800">Re-Schedule Call</span>
        </div>
      }
      open={isOpen}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose} className="rounded-xl font-bold h-10 px-6">
          Cancel
        </Button>,
        <Button 
          key="save" 
          type="primary" 
          onClick={handleSave} 
          disabled={!selectedDate || selectedDate.isBefore(dayjs())}
          className="rounded-xl font-bold h-10 px-8 bg-blue-600 hover:bg-blue-700 shadow-lg shadow-blue-200 border-none"
        >
          Save
        </Button>
      ]}
      width={450}
      className="premium-modal"
      closeIcon={<X size={20} className="text-slate-400 hover:text-slate-600" />}
      centered
    >
      <div className="py-4 space-y-4">
        <div className="p-4 bg-blue-50 border border-blue-100 rounded-2xl">
          <Text className="text-blue-800 font-medium block">
            Rescheduling call for: <span className="font-bold">{recordName}</span>
          </Text>
        </div>

        <div className="space-y-2">
          <label className="text-sm font-bold text-slate-700 block uppercase tracking-wider">
            Select New Date & Time
          </label>
          <DatePicker
            showTime
            format="DD-MMM-YYYY HH:mm"
            className="w-full h-12 rounded-xl border-slate-200 shadow-sm"
            value={selectedDate}
            onChange={setSelectedDate}
            disabledDate={disabledDate}
            placeholder="Choose date and time"
            popupClassName="premium-datepicker"
            getPopupContainer={() => document.body}
          />
          {!selectedDate || selectedDate.isBefore(dayjs()) ? (
            <Text type="danger" className="text-[11px] font-bold">
              * Date and time must be in the future
            </Text>
          ) : null}
        </div>
      </div>
    </Modal>
  );
};

export default RescheduleModalV2;
